export const getABTest = name => {
  if (typeof window === 'undefined' || !document.cookie) return false;
  const splitCookie = document.cookie.split('; ') || [];
  const findCookie = splitCookie.find(item => item.startsWith('TestAB_Groups') || item.startsWith('exp-feature-toggle')) || '';
  const cookieValue = findCookie.split('=')[1] || '';
  const variant = cookieValue.includes(name);
  return variant;
};